// Rola zawodnika (runners.role z sledz-api): runner / out_of_competition / staff / media.
// Zastępuje umowną kategorię 10. Obsługa i media są poza wynikami i statystykami (jak dawniej
// kategoria 10), „poza klasyfikacją” ma czas, ale bez miejsca. Stare odpowiedzi API nie mają
// `role` — wtedy kategoria 10 = obsługa. Ten sam kod: sledz-app (utils/runnerRole.js), sledz-org.

export const ROLES = Object.freeze({
  RUNNER: 'runner',
  OUT_OF_COMPETITION: 'out_of_competition',
  STAFF: 'staff',
  MEDIA: 'media',
})

export const LEGACY_STAFF_CATEGORY_ID = 10

const ALL = Object.values(ROLES)

export function roleOf(runner) {
  const stored = runner && runner.role
  if (ALL.includes(stored)) return stored
  return Number(runner && runner.category_id) === LEGACY_STAFF_CATEGORY_ID ? ROLES.STAFF : ROLES.RUNNER
}

// Obsługa albo media — nie zawodnicy: poza listami wyników i statystykami.
export function isSupportRole(runner) {
  const role = roleOf(runner)
  return role === ROLES.STAFF || role === ROLES.MEDIA
}

// Bierze miejsce w rankingach (kategoria, K/M, lider): tylko zawodnik.
export function isClassified(runner) {
  return roleOf(runner) === ROLES.RUNNER
}
